import CopyToClipboard from "@/components/copy-to-clipboard.tsx";
import { useGlobals } from "@/components/providers/globals-provider.tsx";
import Icon from "@/components/ui/icon";
import LinearLoader from "@/components/ui/linear-loader.tsx";
import useShortCode from "@/features/sub-families/hooks/use-short-code.ts";
import { trackEvent } from "@/features/tracking/lib/tracking.ts";
import { useTranslations } from "@/features/translations/components/translations";
import type { Nullable } from "@/types";

type Props = { smartNumber: Nullable<string> };
export default function ShortCode({ smartNumber }: Props) {
    const t = useTranslations();
    const { locale, site } = useGlobals();
    const { shortCode, isLoading } = useShortCode(smartNumber);

    if (isLoading) {
        return <LinearLoader />;
    }

    if (!shortCode) {
        return null;
    }

    const trackCopy = () => {
        trackEvent("3d-copy-to-clipboard", { shortCode, component: "summary", locale, site });
    };

    return (
        <div className="your-product-code__short-code">
            <span>
                {t("short_code")}: <span>{shortCode}</span>
            </span>
            <CopyToClipboard variant="link" data={shortCode} onClick={trackCopy}>
                <Icon name="copy-file" />
            </CopyToClipboard>
        </div>
    );
}
